/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {CURRENCIES} from './iso-currencies';
import {formatLocaleNumber} from '../../app/common/locale/locale-number-format';

function formatCurrencyAmount(amount: any, symbol: string, fractionSize: number, locale: string): string {
  const numericAmount = Number(amount);
  const formatted = formatLocaleNumber(Math.abs(numericAmount), `1.${fractionSize}-${fractionSize}`, locale);
  if (numericAmount < 0) {
    return '(' + symbol + formatted + ')';
  }
  return symbol + formatted;
}

export function formatIsoCurrency(
  amount: any,
  currencyCode?: string,
  fraction?: number,
  hideCurrency?: boolean,
  hideExtras?: boolean,
  defaultCurrency?: string,
  locale = 'en'
): any {
  const currency = CURRENCIES[(currencyCode || 'NOMATCH').toUpperCase()];

  if (!currency) {
    return amount;
  }

  let fractionSize = !_.isFinite(fraction) ? currency.fraction : fraction;
  fractionSize = hideExtras && amount % 1 === 0 ? 0 : fractionSize;
  const updatedCurrency = formatCurrencyAmount(
    amount,
    hideCurrency ? '' : currency.symbol || currencyCode + ' ',
    fractionSize,
    locale
  );
  if (updatedCurrency) {
    if (CURRENCIES[defaultCurrency] && CURRENCIES[defaultCurrency].symbol === currency.symbol) {
      return updatedCurrency.replace(currency.symbol, hideCurrency ? '' : currencyCode + ' ');
    }
  }
  return updatedCurrency;
}

export function stringToCurrency(value: any, defaultCurrency?: string, locale = 'en'): any {
  if (!_.isString(value)) {
    return value;
  }
  const currency = CURRENCIES[value.substr(0, 3)];
  if (!currency) {
    return value;
  }
  const currencySplit = value.split(' ');
  if (currencySplit.length !== 2 || currencySplit[0].length !== 3) {
    return value;
  }
  return formatIsoCurrency(currencySplit[1], currencySplit[0], undefined, undefined, undefined, defaultCurrency, locale);
}
